import { useParams } from '../../router/hooks/useParams'
import { Page } from '../../theme/components/Page'
import { PageSection } from '../../theme/components/PageSection'
import { StyledCard } from '../../theme/components/StyledCard'
import { StyledExpandCard } from '../../theme/components/StyledExpandCard'
import { Detail } from '../components/Detail'
import { History } from '../components/History'
import { Status } from '../components/Status'
import { Werkzaamheden } from '../components/Werkzaamheden'
import { useOpdracht } from '../hooks/useOpdracht'

export const Opdracht = () => {
  /* v8 ignore next - TODO: missing coverage -- @preserve */
  const { id = '' } = useParams()
  const { data: opdracht, isLoading, isError } = useOpdracht({ id })

  if (isLoading) {
    return
  }

  return (
    <Page
      title={[opdracht ? `Opdracht ${opdracht.opdrachtId}` : 'Opdracht']}
      breadcrumbs={[
        { label: 'Aansluiting', href: '/home', tooltip: 'CAPO home' },
        {
          label: 'Opdrachten',
          href: '/opdrachten',
          tooltip: 'Opdrachten overzicht',
        },
        { label: opdracht ? opdracht.opdrachtId : 'Opdracht' },
      ]}
    >
      <PageSection
        id="opdracht"
        heading={isError ? 'Opdracht niet gevonden' : `Opdracht ${id}`}
      />

      {opdracht?.opdrachtId && (
        <>
          <StyledCard title="Gegevens">
            <Detail opdracht={opdracht} />
          </StyledCard>
          <StyledExpandCard title="Status">
            <Status opdracht={opdracht} />
          </StyledExpandCard>
          {opdracht.details?.werkzaamheden && (
            <StyledExpandCard title="Werkzaamheden">
              <Werkzaamheden opdracht={opdracht} />
            </StyledExpandCard>
          )}
          <StyledExpandCard title="Historie">
            <History history={opdracht.history} />
          </StyledExpandCard>
        </>
      )}
    </Page>
  )
}
